import React, { useState, useEffect } from 'react';
import './SimplePopup.css';
import { useLocation } from 'react-router-dom';

const SimplePopup = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Only show popup if on home page and it's a refresh (not navigation)
        const isHome = location.pathname === '/';
        const isRefresh = window.performance && window.performance.navigation && window.performance.navigation.type === 1;
        if (isHome && isRefresh) {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setIsVisible(false);
            setIsMinimized(false);
        }
    }, [location]);

    const closePopup = () => {
        console.log('Closing popup');
        setIsVisible(false);
        setTimeout(() => {
            setIsMinimized(true);
        }, 300);
    };

    const reopenPopup = () => {
        console.log('Reopening popup');
        setIsVisible(true);
        setIsMinimized(false);
    };

    const forceShowPopup = () => {
        console.log('Force showing popup');
        setIsVisible(true);
        setIsMinimized(false);
    };

    console.log('Popup state:', { isVisible, isMinimized });

    return (
        <>
            {/* Test Button - Remove this later */}
            {/* <button 
                onClick={forceShowPopup}
                style={{
                    position: 'fixed',
                    top: '10px',
                    right: '10px',
                    background: 'red',
                    color: 'white',
                    border: 'none',
                    padding: '10px',
                    borderRadius: '5px',
                    zIndex: 10000,
                    cursor: 'pointer'
                }}
            >
                TEST POPUP
            </button> */}

            {/* Main Popup */}
            {isVisible && (
                <div className="popup-overlay">
                    <div className="popup-container" style={{
                        height: '90vh',
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <button className="close-btn" onClick={closePopup}>×</button>
                        <div className="popup-content">
                            <img src="/images/creative-agency/newpopup.jpeg" alt="Special Offer"  style={{height: ''}}/>
                        </div>
                    </div>
                </div>
            )}

            {/* Minimized Button */}
            {isMinimized && (
                <button className="minimized-btn" onClick={reopenPopup}>
                    See Offer
                </button>
            )}

            {/* WhatsApp Floating Button */}
            <a
                href="https://wa.me/923193446483?text=Hi%2C%20I%20want%20to%20know%20more%20about%20Ignite%20Sports%20Pavilion."
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'fixed',
                    bottom: '17px',
                    right: '30px',
                    backgroundColor: '#25d366',
                    color: '#fff',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    textAlign: 'center',
                    fontSize: '30px',
                    boxShadow: '2px 2px 3px #999',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                    zIndex: 9999,
                    cursor: 'pointer',
                }}
                aria-label="Chat on WhatsApp"
            >
                <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
                    <path d="M16 3C9.373 3 4 8.373 4 15c0 2.65.87 5.1 2.36 7.1L4 29l7.18-2.32C13.1 27.13 14.53 27.5 16 27.5c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.3 0-2.57-.25-3.75-.74l-.27-.11-4.25 1.38 1.38-4.13-.18-.28C6.25 18.07 6 16.56 6 15c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.13-7.47c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.28.9-.86 1.08-.16.18-.32.2-.59.07-.28-.14-1.18-.42-2.25-1.34-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.44.12-.58.13-.13.29-.34.43-.5.14-.16.18-.28.28-.47.09-.19.05-.35-.02-.5-.07-.15-.62-1.54-.85-2.1-.22-.55-.45-.48-.62-.49-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.27-.95 1.01-.95 2.46 0 1.45 1.06 2.85 1.21 3.05.15.2 2.09 3.09 5.07 4.33.71.3 1.26.48 1.7.62.71.23 1.36.2 1.87.12.57-.09 1.75-.7 2-1.38.25-.68.25-1.27.17-1.39-.08-.12-.27-.19-.57-.33z"/>
                </svg>
            </a>
        </>
    );
};

export default SimplePopup; 